import { render, staticRenderFns } from "./Bookings.vue?vue&type=template&id=51683e2d&scoped=true"
import script from "./Bookings.vue?vue&type=script&lang=js"
export * from "./Bookings.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/inbox.css?vue&type=style&index=0&id=51683e2d&prod&scoped=true&lang=css&external"
import style1 from "./Bookings.vue?vue&type=style&index=1&id=51683e2d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51683e2d",
  null
  
)

export default component.exports